export default __webpack_public_path__ + "static/media/016.c216fdc3.jpg";